import { MenuIcon } from "lucide-react";
import useHeader from "./useHeader";
import { Sidebar } from "../Sidebar";
import { Dialog } from "@/components";
import {
  Avatar,
  AvatarFallback,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui";
import { images } from "@/assets";
import { roles } from "@/lib/utils";

const Header = () => {
  const {
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    loggedInUserData,
  } = useHeader();

  return (
    <>
      <header className="bg-primary-100 fixed w-full flex items-center px-4 z-50">
        {/* This only for mobile menu */}
        <div className="flex flex-row items-center justify-between">
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger className="lg:hidden" asChild>
              <Button variant="ghost">
                <MenuIcon />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full ml-[20px] bg-white p-3 shadow-lg rounded-sm">
              <Sidebar handleClose={handleClose} />
            </PopoverContent>
          </Popover>
          <div className="flex flex-row items-center justify-between">
            <img src={images.logo} className="w-[200px] md:w-[100px]" />
          </div>
        </div>
        <div className="flex justify-end w-full items-center relative">
          <Button
            type="button"
            onClick={onLogoutClick}
          >
            Logout
          </Button>
          {/* For Profile Menu */}
          <div className="cursor-pointer flex flex-row items-center justify-between border-l-1 border-g-200 py-2 px-3 ml-3 w-[120px] md:w-[130px] gap-3">
            <Avatar className="h-[40px] w-[40px]">
              {/* <AvatarImage
                src="https://github.com/shadcn.png"
                alt="@shadcn"
              /> */}
              <AvatarFallback className="bg-primary text-black">{`${loggedInUserData?.fullName
                ?.split(" ")?.[0]
                ?.charAt(0)
                ?.toUpperCase()}${loggedInUserData?.fullName
                ?.split(" ")?.[1]
                ?.charAt(0)
                ?.toUpperCase()}`}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col item-center justify-center">
              <span className="text-[12px] text-g-500 text">
                {loggedInUserData?.fullName?.split(" ")?.[0] || ""}
              </span>
              <span className="text-[12px] text-g-300">
                {loggedInUserData?.roleProjectMap?.some((role: any) => role.roleCode == roles.pm.value) ? "PM" : "Admin"}
              </span>
            </div>
          </div>
        </div>
      </header>
      {isLogoutOpen && (
        <Dialog
          open={isLogoutOpen}
          setOpen={setIsLogoutOpen}
          title={<h2 className="text-2xl font-bold">Logout</h2>}
          onSave={onLogout}
          saveText="Logout"
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to logout?</p>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default Header;
